import React from "react";
import "./style.scss";

function InvalidKey() {
  return (
    <div className="InvalidKey-container" style={{ flex: 1,}}>
      <div className="InvalidKey-view">
        <div>
          <p className="InvalidKey-content">Invalid Access Key</p>
          <p className="suggestion">Please Try with a Valid Key</p>
        </div>
      </div>
    </div>
  );
}
export default InvalidKey;
